export const defaultFeatureConfig = [
  {value: "scraper", label: "LinkedIn Scraper", class: "bg-blue-100 text-blue-800"},
  {value: "inviter", label: "Event Inviter", class: "bg-green-100 text-green-800"},
  {value: "messenger", label: "Group Messenger", class: "bg-purple-100 text-purple-800"},
  {value: "singleCapture", label: "Single Capture", class: "bg-orange-100 text-orange-800"},
  {value: "networkScraper", label: "Network Scraper", class: "bg-gray-100 text-gray-800"},
];